import { type ReactNode } from 'react';
import { Stepper } from '../common/Stepper';
import './AuthLayout.css';

interface AuthLayoutProps {
  children: ReactNode;
  currentStep?: number;
}

const steps = [
  { id: 1, title: 'Criar sua conta' },
  { id: 2, title: 'Configurar espaço' },
  { id: 3, title: 'Completar perfil' },
];

export function AuthLayout({ children, currentStep = 1 }: AuthLayoutProps) {
  return (
    <div className="auth-layout">
      {/* Left side: Hero area */}
      <div className="auth-hero">
        <div className="auth-hero-bg" />
        <div className="auth-hero-content animate-fade-in-up">
          <h1 className="auth-hero-title">Comece<br/>Conosco</h1>
          <p className="auth-hero-subtitle">
            Siga estes passos simples para registrar a sua conta corporativa.
          </p>
          
          <div className="auth-hero-stepper-container">
            <Stepper steps={steps} currentStep={currentStep} />
          </div>
        </div>
      </div>

      {/* Right side: Form area */}
      <div className="auth-content">
        <div className="auth-content-inner animate-fade-in-up">
          {children}
        </div>
      </div>
    </div>
  );
}
